import React from 'react';

const EyeOpenIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_574_855)">
      <path
        d="M14.0945 8.78873C11.1956 8.78873 8.84449 11.1399 8.84449 14.0387C8.84449 16.9376 11.1956 19.2887 14.0945 19.2887C16.9934 19.2887 19.3445 16.9385 19.3445 14.0387C19.3445 11.139 16.9942 8.78873 14.0945 8.78873ZM14.0945 17.5387C12.1642 17.5387 10.5542 15.9305 10.5542 14.0002C10.5542 12.07 12.124 10.5002 14.0542 10.5002C15.9845 10.5002 17.5542 12.07 17.5542 14.0002C17.5542 15.9305 16.0247 17.5387 14.0945 17.5387ZM27.9912 13.7972C27.9807 13.7535 27.986 13.7062 27.9729 13.6634C27.9676 13.645 27.9554 13.6345 27.9492 13.6187C27.9396 13.5942 27.9422 13.5645 27.9291 13.5409C25.3837 7.71335 19.8992 4.36035 14.0542 4.36035C8.20924 4.36035 2.61449 7.7081 0.0682439 13.5356C0.0577439 13.5601 0.0594939 13.5855 0.0498689 13.6135C0.0437439 13.631 0.0314939 13.6397 0.0253689 13.6564C0.0122439 13.7001 0.0174939 13.7465 0.00874389 13.7911C-0.0070061 13.8699 -0.0218811 13.9469 -0.0218811 14.0265C-0.0218811 14.1061 -0.0070061 14.1814 0.00874389 14.261C0.0174939 14.3047 0.0113689 14.3529 0.0253689 14.394C0.0306189 14.4141 0.0437439 14.422 0.0498689 14.4395C0.0586189 14.4631 0.0568689 14.4929 0.0682439 14.5174C2.61449 20.3431 8.15499 23.6418 14 23.6418C19.845 23.6418 25.3846 20.3501 27.93 14.5226C27.9431 14.4972 27.9405 14.4719 27.9501 14.4439C27.9562 14.429 27.9676 14.4176 27.9729 14.4001C27.986 14.3572 27.9825 14.3109 27.9912 14.2654C28.007 14.1866 28.021 14.1105 28.021 14.0291C28.021 13.9521 28.0061 13.876 27.9904 13.7964L27.9912 13.7972ZM14 21.8918C9.04312 21.8918 4.16324 19.2791 1.76574 14.0256C4.14049 8.79048 9.08512 6.10948 14.0542 6.10948C19.0225 6.10948 23.8569 8.7931 26.2325 14.0309C23.8586 19.2651 18.97 21.8918 14 21.8918Z"
        fill="#B3DCFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_574_855">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default EyeOpenIcon;
